import PageModal from 'components/PageModal/PageModal'
import React from 'react'

export default function AddToDashboard({closeModal}: any) {

    const grids = [
      "Controls Overview",
      "Monte Carlo Simulation",
      "Workforce Planner",
      "Strategy Overview",
      "OKRs",
    ];
    const grid2 = [
      "Jira Kanban Board",
      "Wiki",
      "Freehand",
      "Miro",
      "Documents",
    ];

  return (
    <PageModal>
      <div className="modal-container">
        <div className="d-flex justify-content-end mb-5 pb-3">
          <button
            onClick={() => closeModal()}
            className="btn btn-outline-secondary btn-lg"
          >
            Cancel
          </button>
        </div>

        <h5 className="fw-300">New Dashboard</h5>
        <h1 className="fw-300 ">
          What type of dashboard would you like to add?
        </h1>
        <h4 className="text-gray-400 fw-300">
          Select from the list of applications. You can customize it later.{" "}
        </h4>

        <div className="row g-4 mv-5">
          {grids.map((text, i) => (
            <div className="col" key={i}>
              <div className="bg-gray-900 text-gray-50 pa-4 border-gray-800">
                <div
                  className="circle bg-gray-800 mb-3"
                  style={{ width: "2rem" }}
                >
                  <i className="icon-zap"></i>
                </div>
                <h5 className="fw-300">{text}</h5>
              </div>
            </div>
          ))}
        </div>
        <div className="row g-4 mv-5">
          {grid2.map((text, i) => (
            <div className="col" key={i}>
              <div className="bg-gray-900 text-gray-50 pa-4 border-gray-800">
                <div
                  className="circle bg-gray-800 mb-3"
                  style={{ width: "2rem" }}
                >
                  <i className="icon-zap"></i>
                </div>
                <h5 className="fw-300">{text}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageModal>
  );
}
